(function () {
  if (window.__slideshowV2Bound) return;
  window.__slideshowV2Bound = true;

  const INTERACTIVE_SELECTOR = 'a[href], button, input, select, textarea, [role="button"]';

  function navigate(href) {
    if (!href) return;
    window.location.href = href;
  }

  function onActivate(event) {
    const slide = event.target.closest('.slideshow__item-wrap[data-slide-link]');
    if (!slide) return;
    if (!slide.closest('.section--slideshow-v2')) return;

    const interactive = event.target.closest(INTERACTIVE_SELECTOR);
    if (interactive && slide.contains(interactive) && interactive !== slide) return;

    if (event.type === 'keydown') {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
    }

    navigate(slide.dataset.slideLink);
  }

  document.addEventListener('click', onActivate);
  document.addEventListener('keydown', onActivate);
})();
